<template>
  <v-chart :options="chartOptions" autoresize class="pie-chart" />
</template>

<script>
import ECharts from "vue-echarts"; // Import ECharts wrapper for Vue
import "echarts/lib/component/tooltip"; // Import tooltip for mouseover info
import "echarts/lib/component/legend"; // Import legend component

export default {
  components: {
    "v-chart": ECharts,
  },
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartOptions() {
      let genderCount = {
        Male: 0,
        Female: 0,
      };

      this.chartData.forEach((item) => {
        if (
          item.gender &&
          (item.gender === "Male" || item.gender === "Female")
        ) {
          genderCount[item.gender]++;
        }
      });

      const pieData = Object.keys(genderCount).map((key) => ({
        value: genderCount[key],
        name: key,
      }));

      return {
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            return `${params.seriesName} <br/>${params.name}: ${
              params.value
            } (${params.percent.toFixed(1)}%)`;
          },
        },
        legend: {
          orient: "horizontal",
          top: "top",
          left: "center",
          data: ["Male", "Female"],
        },
        series: [
          {
            name: "Gender",
            type: "pie",
            radius: "48%",
            center: ["50%", "60%"],
            data: pieData,
            label: {
              show: true,
              formatter: "{b}: {c}",
              position: "outside",
              fontSize: 12,
              color: "auto",
            },
            color: ["#3498db", "#ff69b4"],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.pie-chart {
  width: 100%;
  height: 400px;
}
</style>
